module.exports = __webpack_public_path__ + "static/media/nodejs-plain.8f85d265.svg";